/**
 * Calculates revenue statistics projection by year.
 *
 * @param {Object} options - The options for revenue statistics projection.
 * @param {string} options.admNumber - The ADM number.
 * @param {number} [options.year] - The year for which to calculate the projection. If not specified, the current year is assumed.
 * @returns {Object} - The revenue statistics projection.
 * @throws {Error} - If data retrieval for stats projection fails.
 */
import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

export const revenueStatsProjectionByYear = async ({ admNumber, year }) => {
  // if year is not specified, assume current year
  const yearToUse = year && year > 0 ? year : new Date().getFullYear()
  const variables = { admNumber, year: yearToUse }

  const graphiQLQueryObject = [
    {
      method: "admStatsYtdmDetails",
      variables,
      fields: ["year", "month", "admNumber", "revenue", "quantity", "margin", "revenueTarget"],
    },
    {
      method: "admSummary",
      variables,
      fields: ["revenueTarget"],
    },
    {
      method: "admStatsYtd",
      variables,
      fields: ["revenue"],
    },
  ]

  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
  const queryResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data

  if (!queryResponse) throw new Error("Data retrieval for stats projection failed")

  const { admSummary, admStatsYtdmDetails, admStatsYtd } = queryResponse

  return {
    projection: admSummary?.revenueTarget ?? null,
    monthlyRevenue: admStatsYtdmDetails ?? null,
    yearRevenue: admStatsYtd?.revenue ?? null,
  }
}
